import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SiteNav } from '../../components/SiteNav';
import { SiteFooter } from '../../components/SiteFooter';
import { RealmHero } from '../../components/realm/RealmHero';
import { RealmNavigator } from '../../components/realm/RealmNavigator';
import { ArtifactsSection } from '../../components/realm/ArtifactsSection';
import { RealmQuote } from '../../components/realm/RealmQuote';
import { usePageMeta } from '../../hooks/usePageMeta';
import { DEEP, DEEP_ARTIFACTS, DEEP_ARTIFACTS_MORE } from '../../data/deep';

export default function DeepRealm() {
  const { hash } = useLocation();
  usePageMeta({
    title: 'The Deep — Realm I | Ikarus Landed',
    description: 'The ocean answered. Artifacts of dominion, currents, and the unfathomable — The Sovereign, The Seal, The Current, The Tide. Made to order by private commission.',
  });

  useEffect(() => {
    if (hash === '#artifacts') {
      const t = setTimeout(() => document.getElementById('artifacts')?.scrollIntoView({ behavior: 'smooth' }), 150);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    return undefined;
  }, [hash]);

  const explore = () => document.getElementById('artifacts')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <div className="luxury-landing realm realm--deep" data-testid="realm-page-the-deep">
      <SiteNav interest="The Deep" />
      <RealmHero realm={DEEP} onExplore={explore} />
      <RealmNavigator active={DEEP.slug} />
      <ArtifactsSection realm={DEEP} featured={DEEP_ARTIFACTS} more={DEEP_ARTIFACTS_MORE} />
      <RealmQuote quote={DEEP.quote} art={DEEP.quoteArt} />
      <SiteFooter />
    </div>
  );
}
